import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { LayoutFacadeService } from './layout-facade.service';
import { SideMenuComponent } from './components/side-menu/side-menu.component';
import { HeaderComponent } from './components/header/header.component';
import { environment } from '../../environments/environment';
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  imports: [
    SideMenuComponent,
    HeaderComponent,
    AsyncPipe
  ]
})
export class LayoutComponent {
  rootRoutes = [
    { icon: 'home', label: 'Accueil', path: '/', 'data-cy': 'nav-home' },
    ...(environment.showGridTemplatesMenu ? [
      { icon: 'grid_view', label: 'Modèles de grilles', path: 'grid-templates', 'data-cy': 'nav-grid-templates' },
      { icon: 'school', label: 'Attribution de grilles', path: 'apply-grid', 'data-cy': 'nav-apply-grid' },
    ] : []),
    { icon: 'menu_book', label: 'Consultation des grilles', path: 'grid', 'data-cy': 'nav-grid-consultation' },
  ]

  organizationRoutes = [
    { label: 'Gestion des années d\'étude', path: 'school-organization/years-of-study', 'data-cy': 'nav-school-organization-years-of-study' },
    { label: 'Gestion des classes', path: 'school-organization/classes', 'data-cy': 'nav-school-organization-classes' },
    { label: 'Gestion des cours', path: 'school-organization/courses', 'data-cy': 'nav-school-organization-courses' },
  ]

  private facade = inject(LayoutFacadeService)
  private router = inject(Router)
  establishmentRef$ = this.facade.establishmentRef$;
  selectedEstablishment$ = this.facade.selectedEstablishment$;
  currentSchoolYear$ = this.facade.currentSchoolYear$;
  userName = this.facade.userName;

  goTo(url: string) {
    this.router.navigate([url]);
  }

  selectedSchoolChanged(establishmentId: string) {
    this.facade.establishmentFase(establishmentId);
    this.router.navigate(['/']);
  }

  selectedSchoolYearChanged(schoolYear: number) {
    this.facade.currentSchoolYear(schoolYear);
    this.router.navigate(['/']);
  }

  logout() {
    this.facade.logout();
  }
}
